/**
 * Compares two Uint8Arrays for exact byte equality.
 *
 * @param a - First Uint8Array
 * @param b - Second Uint8Array
 * @returns true if both arrays have identical contents, false otherwise
 */
export function uint8ArraysEqual(a: Uint8Array, b: Uint8Array): boolean {
  if (a.length !== b.length) return false;
  for (let i = 0; i < a.length; i++) {
    if (a[i] !== b[i]) return false;
  }
  return true;
}